import { requester } from '../utils';

export const fetchAllFinancialTransactions = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/financialTransaction?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch financial transactions error', err);
        reject(err);
      });
  });
};
export const fetchFinancialTransactionDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/financialTransaction/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch financial transaction error', err);
        reject(err);
      });
  });
};

export const fetchAllUserFinancialTransactions = (userId, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/financialTransaction/user/${userId}?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getConstantReservesReportRequest = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: `v1/financialTransaction/constant-reserves?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getRechargeChairsReportRequest = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: `v1/financialTransaction/recharge-rsee-report?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getPurchasePackagesReport = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: `v1/financialTransaction/purchase-packages-report?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
